<script setup>
import {onMounted, reactive} from "vue"

const props = defineProps({
    isStyled: {
        type: Boolean,
        default: true,
    },
    date: {
      type: Date,
      required: true,
    },
    label: {
        type: String,
        required: true,
    },
    color: {
        type: String,
    },
})

// Constants
const MILLISECONDS_IN_SECOND = 1000
const MILLISECONDS_IN_MINUTE = MILLISECONDS_IN_SECOND * 60
const MILLISECONDS_IN_HOUR = MILLISECONDS_IN_MINUTE * 60
const MILLISECONDS_IN_DAY = MILLISECONDS_IN_HOUR * 24

const state = reactive({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
})

let countDownIntervalId

const emit = defineEmits([
    'timer:end'
])

const countDown = () => {
    const targetDateTime = new Date(props.date).getTime()
    const timeNow = new Date().getTime()
    const difference = targetDateTime - timeNow

    const floorAndPad = (_value) => String(Math.floor(_value)).padStart(2, '0')

    if (difference > 0) {
        state.days = floorAndPad(difference / MILLISECONDS_IN_DAY)
        state.hours = floorAndPad((difference % MILLISECONDS_IN_DAY) / (MILLISECONDS_IN_HOUR))
        state.minutes = floorAndPad((difference % MILLISECONDS_IN_HOUR) / MILLISECONDS_IN_MINUTE)
        state.seconds = floorAndPad((difference % MILLISECONDS_IN_MINUTE) / MILLISECONDS_IN_SECOND)
    } else {
        clearInterval(countDownIntervalId) // Count down stopped
        emit('timer:end')
    }
}

onMounted(() => {
    countDown()
    countDownIntervalId = setInterval(countDown, 1000) // Update every second
})

</script>

<template>
    <div
        v-if="isStyled"
        class="countdownTimerComponent"
    >
        <div :style="color && { 'color': `${color} !important` }" class="divOfferExpires">
            {{ label }}
        </div>
        <div class="divDaysValue">{{ state.days }}</div>
        <div class="divHoursValue">{{ state.hours }}</div>
        <div class="divMinutesValue">{{ state.minutes }}</div>
        <div class="divSecondsValue">{{ state.seconds }}</div>
        <div class="divDaysLabel">DAYS</div>
        <div class="divHoursLabel">HOURS</div>
        <div class="divMinutesLabel">MINUTES</div>
        <div class="divSecondsLabel">SECONDS</div>
    </div>
    <div
        v-else
        class="countdown"
    >
        <div v-if="state.days !== '00'">{{ state.days }} :&nbsp;</div>
        <div v-if="state.days !== '00' && state.hours !== '00'">{{ state.hours }} :&nbsp;</div>
        <div>{{ state.minutes }} :&nbsp;</div>
        <div>{{ state.seconds }}</div>
    </div>
</template>

<style scoped>
    .countdown {
        display: flex;
    }
</style>
